export default __webpack_public_path__ + "static/media/c2.f68befa7.png";